import { ErrorPage } from "./ErrorPage";

export function SmallDevice({
  isDesktop,
  shouldShowRotateMessage,
  shouldShowResizeMessage,
}: {
  isDesktop: boolean;
  shouldShowRotateMessage: boolean;
  shouldShowResizeMessage: boolean;
}) {
  // Show rotation message for mobile/tablet devices
  if (shouldShowRotateMessage) {
    return (
      <ErrorPage>
        <div className="animate-rotate-device border-theme-active h-12 w-24 rounded-[10px] border-[3px]" />
        <div className="mt-10 text-base">Rotér venligst din skærm</div>
      </ErrorPage>
    );
  }

  // Show appropriate not supported message based on device type and reason
  return (
    <ErrorPage
      icon="tablet"
      title="Lasso Sales har brug for mere plads"
      message={
        isDesktop && shouldShowResizeMessage
          ? "Prøv at maksimere dit browservindue, eller prøv på en større skærm"
          : isDesktop
            ? "Brug venligst en computer med større skærm"
            : "Brug venligst en enhed med større skærm"
      }
    />
  );
}
